var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 83.063,
    viewBox: "0 0 105 83.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_184-2",
    x: 7.722,
    y: 0,
    width: 88.902,
    height: 57.327,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.243
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947",
    transform: "translate(6581 -4003.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(567.574 -79.395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7148.57, 4083.33)",
    filter: "url(#Path_184-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184-2-2",
    "data-name": "Path 184-2",
    d: "M1695.906-534.906c-2.413,1.307-5.119,1.168-7.057,3.059a5.7,5.7,0,0,1-.433-.522c-.789-1.31,1.316-3.993-1.428-4.2-4.809-.358-7.474,1.78-8.2,6.1-1.293-.707-1.173-2.084-1.526-3.137a63.632,63.632,0,0,0-5.107-12.255,4.059,4.059,0,0,0-4.174-2.28c-13.826.67-27.59-.732-41.395-.857-2.056-.019-2.905-.638-2.4-2.98,1.093-5.011,2.81-9.814,4.381-14.673.649-2.006,2.068-1.457,3.214-1.355,12.456,1.106,24.956.641,37.441.7,3,.016,5.723-.146,8.054-2.674,1.3-1.41,3.89-2.3,5.114-.613,1.141,1.576,2.774,4.1.177,6.354a21.95,21.95,0,0,0-2.4,2.85c-2.479,3.049-2.558,6.3-.393,9.33.721,1.009,1.42.505,2.124.258,1.723-.6,2.725.087,3.3,1.707.8,2.237,1.935,4.406,2.337,6.718C1688.4-538.477,1690.963-535.648,1695.906-534.906Z",
    transform: "translate(-1608.34 579.52)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/MA.c40ef5b820fa99c9110fbf3c96913305.svg";
export { ForwardRef as ReactComponent };